import { breadcrumbObj } from "@/components/CommonForm/CommonFormInterface";
import { convertToLabel } from "./convertToLabelFromPath";
import getData from "@/commonJS/getData";

export function generateBreadcrumbList({
  field,
  pathname,
  fullGlobalState,
  globalState,
  layoutStore,
  pageStore,
  contextLocale = "en",
}: {
  field: any;
  pathname: string;
  fullGlobalState: any;
  globalState: any;
  layoutStore: any;
  pageStore: any;
  contextLocale?: string;
}): breadcrumbObj[] {
  let arr: breadcrumbObj[] = [];
  const properties = field?.properties;
  let breadcrumbs = field?.breadcrumbs;

  if (properties?.dynamic) {
    arr =
      pathname === "/"
        ? [{ path: "/" }]
        : breadcrumbs?.slice(0, pathname?.split("/")?.length) ?? [];
  } else if (properties?.mixed) {
    if (properties?.position === "end") {
      arr =
        breadcrumbs?.concat({
          path: pathname?.split("/").at(-1),
          label: (properties?.prefix ? properties?.prefix : "") + convertToLabel(pathname?.split("/").at(-1) ?? null),
        }) ?? [];
    }
  } else if (properties?.static) {
    arr = breadcrumbs ?? [];
  } else {
    if (pathname === "/") {
      arr = [{ path: "/" }];
    } else {
      let constructedSlug = "";
      arr = pathname?.split("/").map((slugPart: string, index: number) => {
        constructedSlug += slugPart
          ? `${index > 1 ? "/" : ""}${slugPart}`
          : "/";
        return {
          path: constructedSlug,
          label: convertToLabel(slugPart),
        };
      });
    }
  }

  return (
    arr?.map((bdc: breadcrumbObj) => {
      const storeState =
        field?.dynamicLabel?.source === "GLOBAL"
          ? fullGlobalState
          : field?.dynamicLabel?.source === "REDUX"
          ? { page: pageStore, layout: layoutStore }
          : globalState;

      const extractedLabel =
        typeof bdc?.dynamicLabel === "object"
          ? getData(
              bdc.dynamicLabel,
              storeState,
              globalState,
              fullGlobalState,
              { page: pageStore, layout: layoutStore },
              globalState
            )?.toString() ??
            bdc?.fallback ??
            ""
          : bdc?.label;

      const getLink = () => {
        let href = bdc?.path ?? "/404";
        const locale = contextLocale;
        if (field?.defaultLocale ?? true) {
          if (
            !href?.includes("http") &&
            field?.target !== "_blank" &&
            locale &&
            locale !== "en"
          ) {
            href = "/" + locale + href;
          }
        }
        return href;
      };

      return {
        ...bdc,
        href: getLink(),
        label: extractedLabel,
      };
    }) ?? []
  );
}
